import React, {lazy, Suspense} from "react";
import {Route, Routes} from "react-router-dom";

import SearchByTitle from "../components/searchByTitle";
import SearchByFilters from "../components/searchByFilters";
import Preloader from "../components/preloader";

const MoviePage = lazy(() => import("../pages/moviePage"));
const FavoritePage = lazy(() => import("../pages/favoritePage"));
const SearchMoviePage = lazy(() => import("../pages/homePage"));
const NotFoundPage = lazy(() => import("../pages/notFound"));
export default function PagesRouter(){
    return (
        <Routes>

            <Route path="/:id"
                   element={
                       <Suspense fallback={<Preloader/>}>
                           <MoviePage />
                       </Suspense>
                    }
            />

            <Route path="/favorite"
                   element={
                       <Suspense fallback={<Preloader/>}>
                           <FavoritePage />
                       </Suspense>
                    }
            />

            <Route path="/"
                   element={
                    <Suspense fallback={<Preloader/>}>
                        <SearchMoviePage />
                    </Suspense>
                    }
            >
                <Route index element={<SearchByTitle/>}></Route>
                <Route path="filters" element={<SearchByFilters/>}></Route>
            </Route>

            <Route path="/*" element={
                <Suspense fallback={<Preloader/>}>
                    <NotFoundPage/>
                </Suspense>
                }
            >
            </Route>

        </Routes>
    )
}